import { actions } from './actions'

const initialState = {
  data: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_TOTALPOINTS_RESULT:
      return { ...state, data: action.payload }
    case 'CLEAR_POINTS':
      return { ...state, data: { data: [] } }
    default:
      return state
  }
}
